module.exports = __webpack_public_path__ + "static/media/oneday_3.2d9d2c82.png";